import { useEffect } from "react";
import useCancellationToken, { CancellationToken } from "./useCancellationToken";


export default function useAjaxCall(func: (token: CancellationToken) => any, dependencies: React.DependencyList) {
    const cxt = useCancellationToken();

    useEffect(() => {
        func(cxt);
    }, dependencies);
}

